{
  "admin_dashboard": {
    "title": "Analytiikka",
    "overview": "Yleiskatsaus",
    "totalUsers": "Käyttäjät yhteensä",
    "roundsCompleted": "Kierrokset",
    "competitions": "Kilpailut",
    "registrations": "Ilmoittautumiset",
    "last30Days": "viim. 30 pv",
    "trends": "Trendit",
    "date": "Päivä",
    "newUsers": "Uudet käyttäjät",
    "rounds": "Kierrokset",
    "featureUsage": "Ominaisuuksien käyttö",
    "ebirdieUsage": "eBirdie-käyttäjät",
    "socialFeatures": "Sosiaalisten ominaisuuksien käyttäjät",
    "paceTracking": "Pelitahdin seuranta",
    "weeklyCompetitions": "Viikkokilpailujen käyttäjät",
    "payments": "Maksaneet käyttäjät",
    "timePeriod": "Aikajakso",
    "days7": "7 päivää",
    "days14": "14 päivää",
    "days30": "30 päivää",
    "days90": "90 päivää",
    "noData": "Ei dataa saatavilla",
    "error_load": "Tietojen lataaminen epäonnistui"
  },
  "course_analytics": {
    "title": "Kenttäanalyysi",
    "filters": "Suodattimet",
    "course": "Kenttä",
    "select_course": "Valitse kenttä",
    "start_date": "Alkaen",
    "end_date": "Asti",
    "min_handicap": "Min HCP",
    "max_handicap": "Max HCP",
    "rounds": "kierrosta",
    "hole": "Reikä",
    "par": "Par",
    "avg_score": "Tuloskeskiarvo",
    "difficulty": "Vaikeus",
    "current_hcp": "HCP",
    "calculated_hcp": "Laskennallinen HCP",
    "hcp_diff": "Ero",
    "eagle_or_better": "Eagle tai parempi",
    "birdies": "Birdie",
    "pars": "Par",
    "bogeys": "Bogey",
    "double_or_worse": "Tuplabogey tai huonompi",
    "no_data": "Ei dataa",
    "select_course_prompt": "Valitse kenttä nähdäksesi analytiikkatiedot",
    "round_type": "Kierrostyyppi",
    "all_rounds": "Kaikki kierrokset",
    "competition_rounds": "Kilpailukierrokset",
    "practice_rounds": "Harjoituskierrokset",
    "search": "Hae",
    "eagle_short": "Eagle-",
    "birdie_short": "Birdie",
    "bogey_short": "Bogey",
    "double_short": "2Bogey+",
    "kicker": "Kenttäanalyysi · Tulokset",
    "period": "Jakso",
    "hcp_range": "Tasoitusrajaus",
    "rounds_section": "Kierrokset",
    "hardest_hole": "Vaikein reikä",
    "easiest_hole": "Helpoin reikä",
    "quick_nav_meta": "Par {{par}} · ka {{avg}}",
    "table_section": "Taulukko",
    "table_hint": "kaikki {{count}} reikää · klikkaa riviä nähdäksesi jakauman",
    "calculated_hcp_short": "Lask. HCP",
    "holes_section": "Reiät",
    "n_count": "n={{count}}",
    "avg_vs_par": "Keskiarvo suhteessa pariin",
    "distribution": "Jakauma",
    "difficulty_total": "Vaikeus yht.",
    "export_pdf": "Lataa PDF",
    "pdf_page": "Sivu {{page}} / {{pages}}",
    "pdf_table_meta": "kaikki {{count}} reikää",
    "pdf_hcp_all": "Ei rajausta"
  }
}
